import http from "../httpService";

export async function getRemoteLogUserDetails() {
  try {
    const endpoint =
      "/api/get_remote_log_client_details/get_remote_log_client_details";
    const response = await http.get(endpoint);
    return response.data?.data[0][0][0];
  } catch {
    return null;
  }
}

export async function getRemoteLogUserDetailsWithTenantcode({
  customer_code,
}: {
  customer_code?: string;
}) {
  try {
    const endpoint =
      "/api/get_remote_log_client_details/get_remote_log_client_details";

    const response = await http.get(endpoint, {
      params: customer_code
        ? { tenantcode: customer_code } // 👈 key-value pair
        : undefined,
    });

    return response.data?.data?.[0]?.[0]?.[0] ?? null;
  } catch (error) {
    console.error("getRemoteLogUserDetailsWithTenantcode error", error);
    return null;
  }
}
